import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { fileUploadType } from 'src/types/banners';
import { OnboardingItemType } from 'src/types/onboarding';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class OnboardingRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getOnboardingDetails(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.personalization.onboarding.details,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateOnboarding(
    updatedOnboarding: OnboardingItemType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.personalization.onboarding.update,
      body: updatedOnboarding,
    };

    // const options: HttpTypes.RequestOptions = {
    //   data: _onboardingDetails,
    //   status: 200,
    //   delay: 2000,
    // };

    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async uploadFile(
    file: fileUploadType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.files.upload,
      body: { ...file, optimizateImage: true },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
